import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import logger from "./helpers/logger";

const browserHistory = createBrowserHistory();

const reactPlugin = new ReactPlugin();

// Debug: Log all available environment variables
logger.log("=== Application Insights Debug Info (Vite) ===");
logger.log("All environment variables:", import.meta.env);
logger.log("VITE_ENVIRONMENT:", import.meta.env.VITE_ENVIRONMENT);
logger.log("VITE_APPINSIGHTS_KEY:", import.meta.env.VITE_APPINSIGHTS_KEY);
logger.log("VITE_APPINSIGHTS_CONNECTION_STRING:",import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING);
logger.log("BASE_URL:",import.meta.env.BASE_URL);

// Environment-specific Application Insights configuration
const appInsightsConfigs = {
  Dev: {
    instrumentationKey:import.meta.env.VITE_APPINSIGHTS_KEY || "c4f031ac-3bb0-4a8a-97bf-5fe2a719d317",
    connectionString:import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ||
      "InstrumentationKey=c4f031ac-3bb0-4a8a-97bf-5fe2a719d317;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=8449119a-55e6-4270-940c-1840b7f7dcce",
  },
  Test: {
    instrumentationKey: import.meta.env.VITE_APPINSIGHTS_KEY,
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
  },
  Prod: {
    instrumentationKey: import.meta.env.VITE_APPINSIGHTS_KEY,
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
  },
};

// Determine environment from VITE_ENVIRONMENT
const environment = import.meta.env.VITE_ENVIRONMENT || "Dev";
const config = appInsightsConfigs[environment] || appInsightsConfigs.Dev;

logger.log(`Application Insights Environment: ${environment}`);
logger.log("Selected config:", config);
logger.log("Instrumentation Key:", config.instrumentationKey);
logger.log("Connection String:", config.connectionString);

// Validate configuration
if (!config.instrumentationKey || !config.connectionString) {
  logger.error(
    `Application Insights configuration missing for environment: ${environment}`
  );
  logger.error("Config object:", config);
}

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: config.instrumentationKey,
    connectionString: config.connectionString,
    extensions: [reactPlugin],
    disableFetchTracking: false,
    disableCookiesUsage: true,
    enableAutoRouteTracking: true, // Tracks page views automatically
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

if (!appInsights.config.instrumentationKey) {
  logger.error("Application Insights Instrumentation Key is missing!");
} else {
  logger.log(
    "Application Insights Key Loaded:",
    appInsights.config.instrumentationKey
  );
  appInsights.loadAppInsights();
}

logger.log("=== End Application Insights Debug Info ===");

export { reactPlugin, appInsights };
